import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as Sentry from '@sentry/browser'
import { translate } from '../../helpers/stringHelpers'
import Alert from '../alert'
import Button from '../button'

export class ErrorBoundary extends Component {
  constructor (props) {
    super(props)
    this.state = { eventId: null }
  }

  static getDerivedStateFromError () {
    return { hasError: true }
  }

  componentDidCatch (error, errorInfo) {
    Sentry.withScope(scope => {
      scope.setExtras(errorInfo)
      scope.setTag('hasBrokenUI', this.state.hasError)
      const eventId = Sentry.captureException(error)
      this.setState({ eventId })
    })
  }

  render () {
    if (this.state.hasError) {
      // const handleFeedbackClick = () => Sentry.showReportDialog({ eventId: this.state.eventId })
      const handleFeedbackClick = () => {
        window.location.href = '/'
      }
      // render fallback UI
      return (
        <div id='app-content--error' className='app-content'>
          <Alert color='danger'>{translate('JSTextCodes_RELOAD_MESSAGE')}</Alert>
          {/* <Button
            color='info'
            onClick={handleFeedbackClick}
          >
            Report feedback
          </Button> */}
          <Button
            color='info'
            onClick={handleFeedbackClick}
          >
            Reload Page
          </Button>
        </div>
      )
    }

    // when there's not an error, render children untouched
    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
}

export default ErrorBoundary
